<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <h2 class="param-title"> {{ labels.title }} </h2> 
        </div>
        <div class="tercero-table-block mt-4" v-if="listaTerceros?.length != 0">
            <CorporateDataTable
                :items="listaTerceros"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="15"
                :page-options="[15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTercero(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTercero()">
                        {{ labels.addThird }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="tercero-table-block mt-4" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showModTercero" @creado="actualizarTabla" @cierraModal="closeModal"/>
        <Editar 
            :modalEditar="showModEditTercero" 
            :infoTercero="dataTercero" 
            @actualizado="actualizarTabla" 
            @eliminado="actualizarTabla"
            @cierraModal="closeModal"
        ></Editar>
    </div>
</template>

<script>
import Tercero from '../../services/Tercero'
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import Crear from './Crear.vue'
import Editar from './Editar.vue'

export default {
    name:'Tercero',
    components:{Crear,Editar,CorporateDataTable},
    data:() => ({
        listaTerceros : [],
        dataTercero : [],
        showModTercero : false,
        showModEditTercero : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Tercero',
                    noRow : 'No hay registros',
                    identification : 'Identificación',
                    digitoVeri : 'Digito verificación',
                    nombre : 'Nombre',
                    telefono : 'Telefono',
                    correo : 'Correo',
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    totalRows: "Registros visibles",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    addThird: "Añadir tercero",
                    filterNit: "Filtrar NIT...",
                    filterName: "Filtrar nombre...",
                    filterPhone: "Filtrar teléfono...",
                    filterEmail: "Filtrar correo..."
                }
            }

            return {
                title : 'Third',
                noRow : 'There are not records',
                identification : 'ID',
                digitoVeri : 'Verification digit',
                nombre : 'Name',
                telefono : 'Phone',
                correo : 'Email',
                noMatches: "No results found",
                searchPlaceholder: "Search in table...",
                rowsPerPage: "Rows per page:",
                totalRows: "Visible records",
                noSort: "No sorting",
                sortAsc: "A-Z / Low to high",
                sortDesc: "Z-A / High to low",
                columns: "Columns",
                showAllColumns: "Show all",
                filters: "Filters",
                clearFilters: "Clear filters",
                addThird: "Add third",
                filterNit: "Filter ID...",
                filterName: "Filter name...",
                filterPhone: "Filter phone...",
                filterEmail: "Filter email..."
            }
        },
        allFields(){
            return [
                { key: 'identificacion', label: this.labels.identification, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'digito_verificacion', label: this.labels.digitoVeri, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'nombre', label: this.labels.nombre, sortable: true, thClass: 'text-center' },
                { key: 'telefono', label: this.labels.telefono, sortable: true, thClass: 'text-center' },
                { key: 'correo', label: this.labels.correo, sortable: true, thClass: 'text-center' }
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'identificacion', type: 'text', placeholder: this.labels.filterNit },
                { key: 'nombre', type: 'text', placeholder: this.labels.filterName },
                { key: 'telefono', type: 'text', placeholder: this.labels.filterPhone },
                { key: 'correo', type: 'text', placeholder: this.labels.filterEmail }
            ]
        },
        tableLabels(){
            return {
                noRow: this.labels.noRow,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                totalRows: this.labels.totalRows,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods:{
        createTercero(){
            this.showModTercero = true
        },
        editTercero(id){
            Tercero.getTerceroById(id)
            .then((res) => {
                this.dataTercero = res.data.tercero
                this.showModEditTercero = true
            })
            .catch((err) => { console.log(err)})
        },
        closeModal(val){
            this.showModTercero = val
            this.showModEditTercero = val
        },
        actualizarTabla(){
            Tercero.getAllTercero()
            .then((res) => {
                this.listaTerceros = res.data.listTercero
            })
            .catch((err) => { console.log(err)})
        }
    },
    mounted(){
        Tercero.getAllTercero()
        .then((res) => {
            this.listaTerceros = res.data.listTercero
        })
        .catch((err) => { console.log(err)})
    }
}
</script>
